import { gridSize } from '@atlaskit/theme';

import { Line, DiffInlineRenderProp } from '../../common/types';
import { useContentWidth } from '../../controllers/content-width-controller';

// Ak Page widths copied from @atlaskit/page because they can't be imported
const defaultGridColumnWidth = gridSize() * 10; // 80
const fixedGridPageWidth = `${defaultGridColumnWidth * 12}px`; // 960

export type Props = {
  inlineContent?: DiffInlineRenderProp;
  line: Line;
  isActive: boolean;
};

export const InlineContent = ({ inlineContent, line, isActive }: Props) => {
  const { oldLine, newLine, content, conflictType, type } = line;

  const contentWidth = useContentWidth();

  return (
    <div
      className="inline-content-wrapper"
      style={{
        width: contentWidth || fixedGridPageWidth,
      }}
    >
      <div
        className={[
          'inline-content',
          type ? `type-${type}` : '',
          conflictType ? `has-conflict-${conflictType}` : '',
          isActive ? 'active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <div className="bitkit-diff-inline-content-container">
          {inlineContent &&
            inlineContent({
              lineFrom: oldLine,
              lineTo: newLine,
              content,
            })}
        </div>
      </div>
    </div>
  );
};
